<template>
  <div class="grid-operations">
    <a v-for="(operation,i) in operations" v-if="operation.visible(params.data)" :key="i" :class="`grid-operations-${operation.type}`" @click="()=>operation.onClick(params.data)">{{ operation.title }}</a>
  </div>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  name: 'OperationRender',
  data() {
    return {
      operations: []
    }
  },
  created() {
    this.operations = this.params.operations
  }
})
</script>

<style lang="scss">
@import "src/styles/element-variables";
.grid-operations{
  a {
    padding: 5px;
  }
  &-primary {
    color: $--color-primary;
  }
  &-success {
    color: $--color-success;
  }
  &-warning {
    color: $--color-warning;
  }
  &-danger {
    color: $--color-danger;
  }
}
</style>
